export const STALE_TIME = 5 * 6 * 1000 // 5 min
